import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { AdMobPlus, BannerAd, InterstitialAd } from '@admob-plus/capacitor';

@Injectable({
  providedIn: 'root'
})
export class AdmobService {
  
  private bannerAd: BannerAd;
  private supported: boolean = false;
  private bannerAdUnitId : string = 'ca-app-pub-9335893231304551/5249204828';
  private interstitialUnitAd : string = 'ca-app-pub-9335893231304551/1771750975';
  private adExpiryInterval : number = 60000;
  private appActivity : IAppAction = {
    timestamp : Date.now(),
    teamCount : 0,
    gameCount : 0
  }

  constructor(private platform: Platform) {
    
    this.initialize();
  }

  initialize() {
    console.log('initializing AdMobPlus service')

    this.platform.ready().then(async () => {
      this.supported = (this.platform.is('ios') || this.platform.is('android'));
      const admobDisabled = localStorage.getItem('AdmobDisabled');
      if (admobDisabled) {
        this.supported = false;
      }

      if (this.supported) {
        if (this.platform.is('ios')) {
          this.bannerAdUnitId = 'ca-app-pub-9335893231304551/5519053167';
          this.interstitialUnitAd = 'ca-app-pub-9335893231304551/8774189311';
        }

        console.log('staring AdMobPlus')

        AdMobPlus.start();
        //await this.admob.start()
        // this.admob.configRequest({
        //   testDeviceIds: [ '3ab6996229bf8cac7e49a65006942d6d', '9FEA1F0E8F9ED23D924138DC505612F9', 'kGADSimulatorID' ]
        // })
        await this.showBannerAd();
        
      }
    })

  }

  appAction(action: any) {
    const dateNow = Date.now();
    console.log(`${action} timestamp delta`, dateNow - this.appActivity.timestamp)

    if(action === 'team') {
      // display app every second time
      this.appActivity.teamCount++;
      if(this.appActivity.teamCount >= 2 && (dateNow - this.appActivity.timestamp) > this.adExpiryInterval) {
        this.showInterstitialAd();
        this.appActivity.timestamp = dateNow;
        this.appActivity.teamCount = 0;
      }
    }
    else if(action === 'game') {
      // display app every 3 times
      this.appActivity.gameCount++;
      if(this.appActivity.gameCount >= 3 && (dateNow - this.appActivity.timestamp) > this.adExpiryInterval) {
        this.showInterstitialAd();
        this.appActivity.timestamp = dateNow;
        this.appActivity.gameCount = 0;
      }
    }
    else if(action === 'start') {
      this.showBannerAd();
    }
  }

  async showBannerAd() {
    console.log('showBannerAd called');
    if (this.supported) {
      console.log('showing BannerAd', this.bannerAdUnitId);

      //this.bannerAdUnitId = 'ca-app-pub-3940256099942544/6300978111';  // test id
      this.bannerAd = new BannerAd({
        adUnitId: this.bannerAdUnitId,
      });
      if (this.platform.is('ios')) {
        await this.bannerAd.show();
      }
    }
  }

  async showInterstitialAd() {
    console.log('showInterstitialAd called');
    if (this.supported) {
      console.log('showing showInterstitialAd', this.interstitialUnitAd);
      const interstitial = new InterstitialAd({
        adUnitId: this.interstitialUnitAd,
      })

      await interstitial.load()
      await interstitial.show()
    }
  }

  disableAdmob() {
    this.supported = false;
    localStorage.setItem('AdmobDisabled', 'true');
    if(this.bannerAd) {
      this.bannerAd.hide();
    }
  }

  enableAdmob() {
    localStorage.removeItem('AdmobDisabled');
    this.supported = (this.platform.is('ios') || this.platform.is('android'));
    this.showBannerAd();
  }
}

export interface IAppAction {
  timestamp: number;
  teamCount: number;
  gameCount: number;
}